import { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'outline' | 'text';
  fullWidth?: boolean;
}

const Button = ({ variant = 'outline', fullWidth = false, className, ...props }: IButtonProps) => (
  <button
    className={classNames(styles.container, styles[`variant-${variant}`], { [styles.fullWidth]: fullWidth }, className)}
    {...props}
  />
);

export default Button;
